import React from "react";
import { FormattedMessage } from "react-intl";

export const PRIORITIES = [
  {
    label: (
      <FormattedMessage
        description="Todo Priority Label Urgent"
        defaultMessage="Urgent"
      />
    ),
    description: (
      <FormattedMessage
        description="Todo Priority Description Urgent"
        defaultMessage="Will be visible on all devices and visualized extra strongly both on Storecast and in the app."
      />
    ),
    value: "URGENT" as const,
  },
  {
    label: (
      <FormattedMessage
        description="Todo Priority Label High"
        defaultMessage="High"
      />
    ),
    value: "HIGH" as const,
  },
  {
    label: (
      <FormattedMessage
        description="Todo Priority Label Default"
        defaultMessage="Default"
      />
    ),
    value: "DEFAULT" as const,
    isDefault: true,
  },
  {
    label: (
      <FormattedMessage
        description="Todo Priority Label Low"
        defaultMessage="Low"
      />
    ),
    value: "LOW" as const,
  },
];

export type TodoPriorityValue = (typeof PRIORITIES)[number]["value"];
